import { csx } from '@vtex/admin-ui'

const styles = {
  input: csx({
    marginTop: '$space-8',
    width: '100%',
    display: 'flex',
    gap: '$space-3',
    '> div': {
      flex: 1,
    },
  }),
  select: csx({
    paddingTop: '1.5rem',
    'select[data-selected]': { color: '$primary' },
  }),
}

export default styles
